<script setup lang="ts">
    import type { PopoverContentEmits, PopoverContentProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { PopoverContent, PopoverPortal, useForwardPropsEmits } from 'reka-ui';
    import { cn } from '../utils';

    const props = withDefaults(defineProps<PopoverContentProps & { class?: HTMLAttributes['class'] }>(), {
        align: 'center',
        sideOffset: 4,
    });
    const emits = defineEmits<PopoverContentEmits>();

    defineOptions({
        inheritAttrs: false,
    });

    const delegatedProps = reactiveOmit(props, 'class');

    const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <PopoverPortal>
        <PopoverContent
            data-slot="popover-content"
            v-bind="{ ...$attrs, ...forwarded }"
            :class="
                cn(
                    'bg-background-primary text-content-primary',
                    ' data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                    'z-50 w-72 rounded-xl border p-[16px] shadow origin-(--reka-popover-content-transform-origin) outline-hidden',
                    '',
                    props.class,
                )
            "
        >
            <slot />
        </PopoverContent>
    </PopoverPortal>
</template>
